<template>
  <div class="col-md-10 offset-md-2">
    <h3>Lista de servidores</h3>
    <b-table striped hover :items="servers" :fields="fields">
      <template v-slot:cell(action)="server">
        <div class="row d-flex justify-content-center">
          <b-button size="sm" variant="primary">Editar</b-button>
          <b-button size="sm" variant="danger">Eliminar</b-button>
          <b-button size="sm" variant="warning" v-b-modal.modal-restartmysql @click="sendInfo(server.item)" >Restart MySQL</b-button>
          
        </div>
      </template>
    </b-table>
    <b-modal id="modal-restartmysql" title="Restart Confirmation" @ok="handleOk()">
      <p class="my-4">Seguro que quieres reiniciar el servicio de MySQL en este servidor?</p>
    </b-modal>
  </div>

</template>

<script>
import {TokenService} from "./../storage/service"

export default {
  name: 'ServerListPage',
  props: {
    msg: String
  },
  data: function () {
    return {
      servers: [],
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'name', label:'Name'},
        {key: 'host', label:'Host/IP'},
        {key: 'action', label:''}
      ],
      selectedUser: '',
    };
  },
  mounted() {
    this.login();
    this.fetchServers();
  },
  methods: {
    login(){
      let token = TokenService.getToken()
      this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
      .then(() => {
        console.log("Token Correcto")
      })
      .catch(err => {
        // catch error});
        if(err.request.statusText == 'Unauthorized'){
          alert("Su sesion ha expirado...")
          this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
        }
        else {
          console.log(err.data)
        }
      })
    },
    handleOk() {
        // Trigger submit handler
        console.log(this.backendURL)
        this.$http.post(this.backendURL + 'api/v1.0/restart_mysql/', this.selectedUser, {timeout: 360000})
      .then(res => {
          // do something with res
          console.log(res.data);
          
      })
      .catch(err => {
          // catch error});
          console.log(err.data)
          
      })
    },
    sendInfo(item) {
        this.selectedUser = item;
    },
    fetchServers() {
      let url = this.backendURL + 'api/v1.0/Server/';
      this.$http.get(url)
      .then( result => {
        //console.log(result.data)
        this.servers = result.data
      })
      .catch(
        err => {
          if(err.request.statusText == 'Unauthorized'){
            alert("Su sesion ha expirado...")
            this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login')
            })
          }
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 0;
}
button {
  margin: 0 5px;
}

.vue-form-generator .field-switch input:checked~.label{
  background: #2f9401;
}

</style>
